<div class="flex flex-col" [formGroup]="subTaskDetailForm">
  <div class="wrapper">
    <div class="cell">
      <mat-label>
        <mat-checkbox [(ngModel)]="startDateEnabled"
                      (change)="onStartStaCheckboxChange($event)"
                      [disabled]="!hasPermission"
                      [ngModelOptions]="{standalone: true}">
          Start Date
        </mat-checkbox>
      </mat-label>
    </div>
    <div class="cell">
      <mat-form-field *ngIf="isSubTask" class="cell-select" appearance="outline">
        <mat-select
          [disabled]="!startDateEnabled || !hasPermission"
          [value]="startDateSelectionType"
          (selectionChange)="onStartDateSelectionTypeChange($event, true)"
        >
          <mat-option *ngFor="let type of selectionTypes" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="date-picker" *ngIf="!relativeStartDateEnabled" appearance="outline">
        <input
          [disableControl]="!startDateEnabled || !hasPermission"
          (dateChange)="onFormValuesChanged()"
          [matDatepicker]="startDatePicker"
          formControlName="taskStartDate"
          matInput
          particleDisableFormControl>
        <mat-datepicker-toggle [disabled]="!hasPermission" [for]="startDatePicker"
                               matSuffix></mat-datepicker-toggle>
        <mat-datepicker #startDatePicker></mat-datepicker>
      </mat-form-field>
      <div class="numbers-cell flex flex-row" *ngIf="relativeStartDateEnabled" formGroupName="relativeStartDate">
        <mat-form-field appearance="outline" class="number m-r-10 m-b-0"
                        style="margin-bottom:0!important">
          <mat-label>Number</mat-label>
          <mat-select [disableControl]="!startDateEnabled || !hasPermission" (selectionChange)="onFormValuesChanged()"
                      formControlName="unit" particleDisableFormControl>
            <mat-option *ngFor="let number of numbers" [value]="number">
              {{number}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="period m-b-0"
                        style="margin-bottom:0!important">
          <mat-label>Period</mat-label>
          <mat-select [compareWith]="compareFunction" [disableControl]="!startDateEnabled || !hasPermission"
                      (selectionChange)="onFormValuesChanged()" formControlName="period" particleDisableFormControl>
            <mat-option *ngFor="let daysType of daysDifferenceType" [value]="daysType">
              {{daysType.displayText}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="wrapper">
    <div class="cell">
      <mat-label>
        <mat-checkbox [(ngModel)]="dueDateEnabled"
                      (change)="onFormValuesChanged()"
                      [disabled]="!hasPermission"
                      [ngModelOptions]="{standalone: true}">
          Due Date
        </mat-checkbox>
      </mat-label>
    </div>
    <div class="cell">
      <mat-form-field *ngIf="isSubTask" class="cell-select" appearance="outline">
        <mat-select
          [disabled]="!dueDateEnabled || !hasPermission"
          [value]="dueDateSelectionType"
          (selectionChange)="onDueDateTypeSelectionChange($event, true)">
          <mat-option *ngFor="let type of selectionTypes" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="date-picker" appearance="outline" *ngIf="!relativeDueDateEnabled">
        <input [disableControl]="!dueDateEnabled || !hasPermission"
               [matDatepicker]="dueDatePicker"
               (dateChange)="onFormValuesChanged()"
               formControlName="dueDate"
               matInput particleDisableFormControl>
        <mat-datepicker-toggle [disabled]="!hasPermission" [for]="dueDatePicker"
                               matSuffix></mat-datepicker-toggle>
        <mat-datepicker #dueDatePicker></mat-datepicker>
      </mat-form-field>

      <div class="numbers-cell flex flex-row" *ngIf="relativeDueDateEnabled" formGroupName="relativeDueDate">
        <mat-form-field appearance="outline" class="number m-b-0"
                        style="
                        margin-bottom:0!important">
          <mat-label>Number</mat-label>
          <mat-select [disableControl]="!dueDateEnabled || !hasPermission" (selectionChange)="onFormValuesChanged()"
                      formControlName="unit" particleDisableFormControl>
            <mat-option *ngFor="let number of numbers" [value]="number">
              {{number}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="period m-b-0"
                        style="margin-bottom:0!important">
          <mat-label>Period</mat-label>
          <mat-select [compareWith]="compareFunction" [disableControl]="!dueDateEnabled || !hasPermission"
                      (selectionChange)="onFormValuesChanged()" formControlName="period" particleDisableFormControl>
            <mat-option *ngFor="let daysType of daysDifferenceType" [value]="daysType">
              {{daysType.displayText}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</div>
